module.exports = __webpack_public_path__ + "static/media/shadowModal.69fac4ab.jpg";